import PlanSalesService from "@/api/services/planSales";
import { toCamelCase } from "@estaly/ui";

export default {
  namespaced: true,

  getters: {
    insurancePlan: () => (plan) => {
      return plan?.contractType === "insurance";
    },
    isMonthDiscount: () => (lead) => {
      return typeof lead?.discount?.type === "string" ? lead.discount.type.split("_")[0] === "months" : false;
    },
    isPromotionOnMonths: (_state, getters) => (lead, offerPrice) => {
      return getters.isMonthDiscount(lead) && !!offerPrice?.recurring;
    },
    isOffered: () => (lead, offerPrice) => {
      return typeof lead?.discount?.type === "string"
        ? lead.discount.type === "months_offered" && !!offerPrice?.recurring
        : false;
    },
    isComposedItemsMutable: () => (plan) => {
      return plan?.composedProductItemsMutable !== false;
    },
  },

  actions: {
    // Returns { verdict, missingFaces, reasons, signedIds, photosVerdictToken }, or null
    // when the request itself failed (the axios interceptor already notified the user).
    // A FAIL verdict comes back with a token too: the customer is warned, not blocked.
    async checkProductItemPhotos(_context, { planSaleId, formData }) {
      const response = await PlanSalesService.checkProductItemPhotos(planSaleId, formData);
      if (!response.success) return null;

      return toCamelCase(response.data);
    },

    async addProductItem(_context, { planSaleId, params }) {
      const { success } = await PlanSalesService.addProductItem(planSaleId, params);
      return success;
    },

    async updateProductItem(_context, { planSaleId, productItemId, params }) {
      const { success } = await PlanSalesService.updateProductItem(planSaleId, productItemId, params);
      return success;
    },
  },
};
